module.exports = {
  "country": "PL",
  "artist": "Tulia",
  "song": "Fire of Love",
  "year": "2019",
  "place": "NQ",
  "spotify": "39eYn0el1oFv3btrhTX74G"
};